import { DynamicObjectInterface } from '../type';
import { AxiosUtilsType, axiosPost } from './axiosUtils';
import './axiosInterceptor';

const AuditLogService = {
  async fetchLog(payload: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`auditLog/list`, payload);
  },
};

export default AuditLogService;
